/** @jsx jsx */
import { jsx, Box as ThemeUIBox, ThemeUIStyleObject } from "theme-ui"
import React from "react"
import { PrimitiveBoxProps, PrimitiveProps } from "@styles/types"

export interface BoxProps
  extends PrimitiveBoxProps,
    PrimitiveProps,
    React.ComponentPropsWithoutRef<"div"> {}

export const boxStyles: ThemeUIStyleObject = {}

const Box: React.FC<BoxProps> = ({ children, sx, ...props }) => (
  <ThemeUIBox sx={{ ...boxStyles, ...sx }} {...props}>
    {children}
  </ThemeUIBox>
)

Box.defaultProps = {}

export { Box }
